"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_Messenger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("title", null, "5944A6AC-3D8B-4361-A4B0-052A2C5CB8D9"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100.001258%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AFF",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3rd-party-icons",
    transform: "translate(-79.000000, -460.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons+Indicators-/-3rd-Party-Icons-/-Messenger-/-App-Launcher",
    transform: "translate(79.000000, 460.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger_Logo_Color_RGB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9839196,0.016080402 C6.97889447,0.016080402 0,6.61226131 0,15.520804 C0,20.1809045 1.91035176,24.2074372 5.02030151,26.9893467 C5.28080402,27.2241206 5.43839196,27.5489447 5.45125628,27.8994975 L5.53809045,30.7425126 C5.56703518,31.6494472 6.50291457,32.2379899 7.33266332,31.8745729 L10.5037186,30.4755779 C10.7738693,30.3565829 11.0729648,30.3340704 11.3559799,30.4112563 C12.8128643,30.8132663 14.3662312,31.0255276 15.9839196,31.0255276 C24.9889447,31.0255276 31.9678392,24.4293467 31.9678392,15.520804 C31.9678392,6.61226131 24.9889447,0.016080402 15.9839196,0.016080402 Z",
    id: "Bubble_Solid_3_",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38713568,20.0554774 L11.0826131,12.6070352 C11.8287437,11.4235176 13.4303518,11.1276382 14.5495477,11.9670352 L18.2834171,14.7682412 C18.6275377,15.0255276 19.0970854,15.0223116 19.4379899,14.7650251 L24.480804,10.9378894 C25.1529648,10.4265327 26.0341709,11.2337688 25.5807035,11.9477387 L20.8884422,19.3929648 C20.1423116,20.5764824 18.5407035,20.8723618 17.4215075,20.0329648 L13.6876382,17.2317588 C13.3435176,16.9744724 12.8739698,16.9776884 12.5330653,17.2349749 L7.48703518,21.0653266 C6.81487437,21.5766834 5.93366834,20.7694472 6.38713568,20.0554774 Z",
    id: "Bolt_4_",
    fill: "#FFFFFF"
  }))))));
}

var _default = ic_Messenger;
exports.default = _default;